import { Aperture, Instagram, Youtube, Mail, Facebook, Linkedin, Film } from "lucide-react";

const socials = [
  { icon: Instagram, href: "https://instagram.com/dboyecreatives", id: "instagram", label: "Instagram" },
  { icon: Youtube, href: "https://youtube.com/@darrelboye", id: "youtube", label: "YouTube" },
  { icon: Facebook, href: "https://facebook.com/dboyecreatives", id: "facebook", label: "Facebook" },
  { icon: Linkedin, href: "https://www.linkedin.com/in/darrelboye/", id: "linkedin", label: "LinkedIn" },
  { icon: Film, href: "https://www.imdb.com/user/p.qno3bkdw7tcgpuxseo5mqmaviu", id: "imdb", label: "IMDb" },
  { icon: Mail, href: "mailto:getskills@darrelboye.com", id: "mail", label: "Email" },
];

const ventures = [
  { name: "Oceans Records", desc: "Record Label", href: "https://oceansrecords.com" },
  { name: "The Craftsmill", desc: "Freelance Creative Development", href: "https://thecraftsmill.com" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-6">
              <Aperture className="w-7 h-7 text-[#D90429]" />
              <span className="font-head text-xl tracking-[0.25em] uppercase text-white">DBoye Creatives</span>
            </div>
            <p className="font-body text-sm text-gray-400 leading-relaxed">
              Cinematic storytelling by Darrel Boye. Videography, photography, design and education for bold brands and
              good causes.
            </p>
          </div>

          <div className="flex flex-wrap gap-12 sm:gap-16">
            <div>
              <p className="font-body text-xs uppercase tracking-[0.2em] text-gray-500 mb-5">Explore</p>
              <ul className="space-y-3">
                {["services", "rates", "nonprofit", "booking"].map((id) => (
                  <li key={id}>
                    <button
                      data-testid={`footer-link-${id}`}
                      onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                      className="font-body text-sm text-gray-300 hover:text-[#EF233C] transition-colors capitalize"
                    >
                      {id}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="font-body text-xs uppercase tracking-[0.2em] text-gray-500 mb-5">Other Ventures</p>
              <ul className="space-y-4">
                {ventures.map((v) => (
                  <li key={v.name}>
                    <a
                      href={v.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`footer-venture-${v.name.toLowerCase().replace(/\s+/g, "-")}`}
                      className="group block"
                    >
                      <span className="font-head uppercase text-sm tracking-[0.1em] text-gray-200 group-hover:text-[#EF233C] transition-colors">
                        {v.name}
                      </span>
                      <span className="block font-body text-xs text-gray-500">{v.desc}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="font-body text-xs uppercase tracking-[0.2em] text-gray-500 mb-5">Connect</p>
              <div className="flex flex-wrap gap-4 max-w-[140px]">
                {socials.map(({ icon: Icon, href, id, label }) => (
                  <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    data-testid={`footer-${id}`}
                    className="text-gray-300 hover:text-[#EF233C] transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-body text-xs text-gray-500">© {new Date().getFullYear()} DBoye Creatives. All rights reserved.</p>
          <p className="font-body text-xs text-gray-500 uppercase tracking-[0.2em]">Cinematographer · Director · Editor</p>
        </div>
      </div>
    </footer>
  );
};
